var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "d97ff1fe-6345-4ce1-a8f3-73608b502c78",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "85af7c5e-9ee7-4963-b53d-be62c5135f92",
    cx: 14.99,
    cy: 15.03,
    r: 11.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#faee7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fbe571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fed659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "13b2846e-f948-4d9c-b147-3b6d2e7ba7bb",
    cx: 15,
    cy: 20.29,
    r: 1.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3837e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ee7c77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e26964"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "96b16a95-490e-40f1-912e-56ed7e33953f",
    cx: 10.16,
    cy: 16.45,
    r: 2.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a94b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#188db2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#14799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0d5a7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073e5e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bfd8230f-d66c-4015-b423-c38e1e54c8c1",
    cx: 20.16,
    cy: 16.56,
    r: 2.5,
    xlinkHref: "#96b16a95-490e-40f1-912e-56ed7e33953f"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a8170640-4b8c-48fb-b519-588a0355d96c",
    cx: 9.45,
    cy: 26.01,
    r: 5.5,
    gradientTransform: "translate(-23.25 36.2) rotate(-91.3) scale(1 1.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b5edef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#78dfe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61d9dc"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconDeath") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "794175f5-68c4-4a1d-b44c-64b720bac25e",
    "data-name": "HEAD",
    d: "M26.74,21c-1.17,2-3.83,3.82-7.19,4.72a16.24,16.24,0,0,1-1.76.37l-.49,0c-.55,0-1.12.07-1.73.08l-.58,0h0l-.58,0c-.52,0-1,0-1.49-.06-.25,0-.49,0-.73-.06a16.24,16.24,0,0,1-1.76-.37c-3.36-.9-6-2.73-7.19-4.72a4.12,4.12,0,0,1-.62-2.73c0-.1,0-.2.07-.31a5.54,5.54,0,0,1,.21-.57A4,4,0,0,0,3.12,17a3.1,3.1,0,0,0,.21-.58,3.11,3.11,0,0,0,.11-.91,1.93,1.93,0,0,0,0-.24c0-.13,0-.27,0-.41a15.41,15.41,0,0,1,.48-4.29,11,11,0,0,1,4.3-5,11.71,11.71,0,0,1,4-1.53c.37-.07.74-.13,1.12-.17s.68-.07,1-.08l.65,0h.47q.49,0,1,.06c.38,0,.76.09,1.12.15A11.93,11.93,0,0,1,21.77,5.6a11.1,11.1,0,0,1,4.31,5,15.8,15.8,0,0,1,.48,4.29c0,.14,0,.28,0,.41s0,.16,0,.24A3.38,3.38,0,0,0,26.85,17a4,4,0,0,0,.23.39,3,3,0,0,1,.21.57c0,.11.05.21.07.31A4,4,0,0,1,26.74,21Z",
    style: {
      fill: "url(#85af7c5e-9ee7-4963-b53d-be62c5135f92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "56c29350-6695-4530-964d-0bd23f37b7ef",
    "data-name": "SHADOW",
    d: "M26.69,21c-1.17,2-3.83,3.82-7.19,4.72a16.58,16.58,0,0,1-1.75.37c-.7.07-1.44.11-2.23.12l-.58,0h0l-.58,0q-1.18,0-2.22-.12a16.24,16.24,0,0,1-1.76-.37C7,24.82,4.36,23,3.18,21a4.21,4.21,0,0,1-.65-2.48c0,.05,0,.11,0,.16a4.48,4.48,0,0,0,.63,1.74c1.18,2,3.83,3.82,7.19,4.72a16.24,16.24,0,0,0,1.76.37q1,.1,2.22.12l.58,0h0l.58,0c.79,0,1.53-.05,2.23-.12a16.58,16.58,0,0,0,1.75-.37c3.36-.9,6-2.73,7.19-4.72a4.48,4.48,0,0,0,.63-1.74.88.88,0,0,0,0-.16A4.14,4.14,0,0,1,26.69,21Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "4c393f6c-45b0-4aa8-bacf-fc6eb93031f4",
    "data-name": "EARS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6,6c-.32.34-.63.7-.94,1.07l-.09.1a15.09,15.09,0,0,0-1.2,1.66,10.14,10.14,0,0,0-.55.95,12.43,12.43,0,0,0-1.34,4,8.89,8.89,0,0,1-.5-1,8.75,8.75,0,0,1-.07-6.45L3,6.18c.07-.18.15-.36.23-.53l0,0a1.28,1.28,0,0,1,.56-.37h.64a7.92,7.92,0,0,1,2.36.42h0A7.85,7.85,0,0,1,7.6,6Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37,8.81a10.14,10.14,0,0,0-.55.95,12.43,12.43,0,0,0-1.34,4,8.89,8.89,0,0,1-.5-1,8.75,8.75,0,0,1-.07-6.45A4,4,0,0,1,5.37,8.81Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.32,6c.32.34.63.7.94,1.07A15.26,15.26,0,0,1,25.1,9.76a12.43,12.43,0,0,1,1.34,4A8.56,8.56,0,0,0,27,6.18l-.23-.53,0,0a1.2,1.2,0,0,0-.56-.37h-.64a7.92,7.92,0,0,0-2.36.42h0C22.85,5.75,22.58,5.86,22.32,6Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.54,8.87c.19.32.38.64.55,1a12.49,12.49,0,0,1,1.33,4,6.83,6.83,0,0,0,.5-1A8.63,8.63,0,0,0,27,6.41,4,4,0,0,0,24.54,8.87Z",
    style: {
      fill: "#f1b02e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "49e412b8-e080-42c3-a147-fd8243be3113",
    "data-name": "NOSE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.38,20.29c0,.41-.62.73-1.38.73s-1.38-.32-1.38-.73.62-.72,1.38-.72S16.38,19.89,16.38,20.29Z",
    style: {
      fill: "url(#13b2846e-f948-4d9c-b147-3b6d2e7ba7bb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.84,20c0,.13-.16.23-.36.23s-.37-.1-.37-.23.17-.23.37-.23S15.84,19.86,15.84,20Z",
    style: {
      fill: "#facac2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "93c8979a-101e-47a2-b491-3df3ad3a608f",
    "data-name": "MOUTH",
    d: "M17.42,24H17A2.54,2.54,0,0,0,13,24h-.38a2.56,2.56,0,0,1,4.84,0Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "18f4a0cf-bd05-4b5d-a365-e60597d5a8d3",
    "data-name": "EYES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,16.36a3.25,3.25,0,0,1-.75,2.08,3.28,3.28,0,0,1-5.65-1.15,3.33,3.33,0,0,1-.07-1.55,8.65,8.65,0,0,0,.89-.11,10.21,10.21,0,0,0,1.27-.28A10.7,10.7,0,0,0,11.65,14l.11-.07.13-.08A3.23,3.23,0,0,1,13,16.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.81,16.16a2.65,2.65,0,0,1-5.3,0,2.22,2.22,0,0,1,0-.37,10.62,10.62,0,0,0,1.27-.28,11.3,11.3,0,0,0,2.92-1.31l.11-.08A2.63,2.63,0,0,1,12.81,16.16Z",
    style: {
      fill: "url(#96b16a95-490e-40f1-912e-56ed7e33953f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.16,18.94a2.8,2.8,0,0,1-2.8-2.78,2.38,2.38,0,0,1,0-.39v-.12h.11a12.81,12.81,0,0,0,1.26-.28,10.89,10.89,0,0,0,2.87-1.29l.12-.08.09-.06.09.07a2.78,2.78,0,0,1-1.78,4.94Zm-2.48-3a1.93,1.93,0,0,0,0,.24,2.5,2.5,0,0,0,5,0,2.43,2.43,0,0,0-.83-1.84h0a11.43,11.43,0,0,1-3,1.33A11,11,0,0,1,7.68,15.92Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.33,15.52a1.76,1.76,0,0,1-3.52,0h0a11.3,11.3,0,0,0,2.92-1.31A1.75,1.75,0,0,1,12.33,15.52Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33,16.7a.56.56,0,1,1-1.12,0,.56.56,0,1,1,1.12,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8,16.4a3.23,3.23,0,0,1-5.78,2A3.17,3.17,0,0,1,18.47,14l.1.06,0,0a10.71,10.71,0,0,0,2.91,1.34,11.69,11.69,0,0,0,1.33.31c.3,0,.6.08.9.1A3.81,3.81,0,0,1,23.8,16.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.81,16.29a2.65,2.65,0,1,1-4.57-1.81,3.71,3.71,0,0,1,.29-.27,11.19,11.19,0,0,0,2.91,1.35,11.37,11.37,0,0,0,1.34.3A3,3,0,0,1,22.81,16.29Z",
    style: {
      fill: "url(#bfd8230f-d66c-4015-b423-c38e1e54c8c1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16,19.07a2.79,2.79,0,0,1-2-4.7c.1-.1.21-.19.32-.28l.08-.06.09.06a11.13,11.13,0,0,0,2.87,1.32,12,12,0,0,0,1.32.3h.11l0,.12a3.19,3.19,0,0,1,0,.45A2.79,2.79,0,0,1,20.16,19.07Zm-1.62-4.66a1.07,1.07,0,0,0-.19.18,2.44,2.44,0,0,0-.68,1.7,2.5,2.5,0,0,0,5,0c0-.1,0-.2,0-.3a10.78,10.78,0,0,1-1.25-.29A11.25,11.25,0,0,1,18.54,14.41Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.44,15.56a1.76,1.76,0,0,1-3.52-.07,1.8,1.8,0,0,1,.57-1.3l0,0A11.19,11.19,0,0,0,21.44,15.56Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1,16.7a.58.58,0,0,1-.56.59A.59.59,0,0,1,21,16.7a.58.58,0,0,1,.57-.59A.57.57,0,0,1,22.1,16.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "379e3b55-eefa-427e-81a1-cf19231eb940",
    "data-name": "EYEBROWS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.54,12.7c0,.36-.75.88-1.71,1.23a3,3,0,0,1-2.06.2A.27.27,0,0,1,7.65,14c-.13-.36.64-1,1.71-1.35s2-.42,2.17-.06A.16.16,0,0,1,11.54,12.7Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.45,12.76c.05.36.76.88,1.72,1.23a3,3,0,0,0,2.06.2.24.24,0,0,0,.12-.14c.13-.35-.64-1-1.71-1.35s-2.05-.42-2.18-.06A.49.49,0,0,0,18.45,12.76Z",
    style: {
      fill: "#f1b02e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13,4.08l0,6.13a.71.71,0,0,1-1.39,0l0-5.87C12.08,4.27,12.54,4.13,13,4.08Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.66,4l0,6.53a.71.71,0,0,1-1.39,0l0-6.53h1.39Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.23,4.22l0,6a.71.71,0,0,1-1.39,0l0-6.15C17.31,4.1,17.77,4.15,18.23,4.22Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24,20.41a11,11,0,0,0-1.91,4.47c-.38,2.71,3.82,2.75,4,.65S9.24,20.41,9.24,20.41Z",
    style: {
      fill: "url(#a8170640-4b8c-48fb-b519-588a0355d96c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82,20.33c.06.28-1.17.82-2.77,1.2S.1,22,0,21.71s1.17-.82,2.76-1.2S5.75,20.05,5.82,20.33Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51,22.75c.09.26-1,.91-2.49,1.45s-2.74.75-2.83.48,1-.91,2.48-1.45S6.41,22.48,6.51,22.75Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.15,20.33c-.07.28,1.17.82,2.77,1.2s2.95.46,3,.18-1.17-.82-2.77-1.2S24.22,20.05,24.15,20.33Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.81,22.85c-.1.27,1,.91,2.48,1.45s2.74.75,2.84.49-1-.92-2.49-1.45S23.91,22.58,23.81,22.85Z",
    style: {
      fill: "#f1b02e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeath);
export default __webpack_public_path__ + "static/media/IconDeath.1a6e2f3a.svg";
export { ForwardRef as ReactComponent };